import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/UserServers.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/servers'

const RouteUserServers = ({ user, history, ...props }) => (
  <Fragment>
    <PaginatedConnectionTable
      {...props}
      history={history}
      fields={fields}
      onRowClick={(e, row) => history.push(`/admin/servers/${row.id}`)}
      showManage
    />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'user.servers'
})(RouteUserServers)



// WEBPACK FOOTER //
// ./src/routes/admin/users/servers/index.js